import React, { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { api, formatApiErrorDetail } from "@/lib/api";

// Teacher's on/off switch for the Monday homework email, plus a "send me it now" preview.
export const HomeworkEmailSetting = () => {
  const [on, setOn] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/teacher/homework-email").then(({ data }) => setOn(data.enabled)).catch(() => setOn(true)); }, []);
  if (on === null) return null;
  const toggle = async (v) => {
    setOn(v);
    try {
      await api.put("/teacher/homework-email", { enabled: v });
      toast.success(v ? "Monday homework email turned on" : "Monday homework email turned off");
    } catch { setOn(!v); toast.error("Could not save that setting"); }
  };
  const preview = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/teacher/homework-email/preview");
      toast.success(data.sent ? "This week's homework email is on its way to your inbox" : "Nothing is due this week or overdue, so there's no email to send");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Could not send the email. Please try again shortly.");
    } finally { setBusy(false); }
  };
  return (
    <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 rounded-xl border border-border bg-background px-4 py-3 text-sm" data-testid="homework-email-setting">
      <label className="flex items-center gap-2">
        <Switch checked={on} onCheckedChange={toggle} data-testid="homework-email-switch" />
        <span>Monday email: homework due this week and who's behind</span>
      </label>
      <button type="button" onClick={preview} disabled={busy} data-testid="homework-email-preview"
        className="inline-flex items-center gap-1.5 rounded-full border border-border px-3 py-1 text-xs text-primary transition-colors hover:border-primary disabled:opacity-50">
        <Mail size={12} /> {busy ? "Sending…" : "Send me this week's email now"}
      </button>
    </div>
  );
};
